import { render, staticRenderFns } from "./PublicList.vue?vue&type=template&id=0cf48d0c&"
import script from "./PublicList.vue?vue&type=script&lang=babel&"
export * from "./PublicList.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports